import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { CommandPalette } from '@/components/layout/CommandPalette';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import SupplyChain from './pages/SupplyChain';
import Kamiony from './pages/Kamiony';
import Statistiky from './pages/Statistiky';
import Planovani from './pages/Planovani';
import Objednavky from './pages/Objednavky';
import SAPIntegrace from './pages/SAPIntegrace';
import DetekceVetvi from './pages/DetekceVetvi';
import VisualFactory from './pages/VisualFactory';
import Avizace from './pages/Avizace';
import CarrierRating from './pages/CarrierRating';
import Login from './pages/Login';
import { TourProvider } from '@/components/tour/TourProvider';
import './App.css';

export const SearchContext = { open: false, setOpen: () => {} };

function App() {
  const [searchOpen, setSearchOpen] = useState(false);

  // Make search open/close available globally
  SearchContext.open = searchOpen;
  SearchContext.setOpen = setSearchOpen;

  return (
    <BrowserRouter>
      <TourProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/supply-chain"
            element={
              <ProtectedRoute>
                <SupplyChain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kamiony/*"
            element={
              <ProtectedRoute>
                <Kamiony />
              </ProtectedRoute>
            }
          />
          {/* Printable monthly carrier rating, outside the app layout */}
          <Route
            path="/statistiky/dopravci/:carrierId"
            element={
              <ProtectedRoute>
                <CarrierRating />
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistiky/*"
            element={
              <ProtectedRoute>
                <Statistiky />
              </ProtectedRoute>
            }
          />
          <Route
            path="/planovani"
            element={
              <ProtectedRoute>
                <Planovani />
              </ProtectedRoute>
            }
          />
          <Route
            path="/objednavky"
            element={
              <ProtectedRoute>
                <Objednavky />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sap"
            element={
              <ProtectedRoute>
                <SAPIntegrace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/detekce-vetvi"
            element={
              <ProtectedRoute>
                <DetekceVetvi />
              </ProtectedRoute>
            }
          />
          {/* Visual Factory — public, no login (TV/tablet in plant) */}
          <Route path="/visual-factory" element={<VisualFactory />} />
          {/* Carrier announcement link — public, no login */}
          <Route path="/avizace/:token" element={<Avizace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CommandPalette open={searchOpen} onOpenChange={setSearchOpen} />
      </TourProvider>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
